var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworkType(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 68.0 68.0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680,0 L1680,1080 L0,1080 L0,0 L1680,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23336329,0 C8.40120683,0 8.56235717,0.0665366188 8.68104592,0.185222404 C8.80007361,0.304241984 8.86660675,0.465396859 8.86660675,0.633227648 L8.86660675,5.69999031 C8.86660675,5.86782966 8.80006847,6.02897598 8.68104592,6.14766176 C8.56235717,6.26635182 8.40119827,6.33321796 8.23336329,6.33321796 L5.06650404,6.33321796 L5.06650404,7.60001561 L6.33333333,7.60001561 L6.33333333,8.86681326 L2.53327342,8.86681326 L2.53327342,7.60001561 L3.80010271,7.60001561 L3.80010271,6.33321796 L0.633243463,6.33321796 C0.465399923,6.33321796 0.304249583,6.26634755 0.18522703,6.14766176 C0.066533145,6.02897598 0,5.8678211 0,5.69999031 L0,0.633227648 C0,0.283520972 0.283519493,0 0.633234904,0 Z M7.60020542,1.26647182 L1.26648693,1.26647182 L1.26648693,5.06643683 L7.60020542,5.06677122 L7.60020542,1.26647182 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26682929,0 L1.26682929,17.099757 L0,17.099757 L0,0 L1.26682929,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6665811,0 L12.6665811,1.26679765 L0,1.26679765 L0,0 L12.6665811,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26682929,0 L1.26682929,12.6662647 L0,12.6662647 L0,0 L1.26682929,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4668122,0 L16.4668122,1.26679765 L0,1.26679765 L0,0 L16.4668122,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0334232,0 C12.2012667,0 12.3624171,0.0665366188 12.4811058,0.185222404 C12.5997989,0.304241984 12.6666667,0.465396859 12.6666667,0.633227648 L12.6666667,9.4993562 C12.6666667,9.66752935 12.5997946,9.82867566 12.4811058,9.94736145 C12.3624171,10.0660515 12.2012582,10.1329176 12.0334232,10.1329176 L6.966534,10.1329176 L6.966534,11.3993729 L9.49985022,11.3993729 L9.49985022,12.6661706 L3.16647409,12.6661706 L3.16647409,11.3993729 L5.70013267,11.3997073 L5.70013267,10.1329096 L0.633243463,10.1329096 C0.465399923,10.1329096 0.304249583,10.0660392 0.18522703,9.9473534 C0.066533145,9.82866762 0,9.66751274 0,9.49934816 L0,0.633219603 C0,0.283512926 0.283519493,0 0.633234904,0 Z M11.4003595,1.26611346 L1.2672658,1.26611346 L1.2672658,8.86612907 L11.4003595,8.86612907 L11.4003595,1.26611346 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23336329,0 C8.40120683,0 8.56235717,0.0665441506 8.68104592,0.185229936 C8.80007361,0.304249516 8.86660675,0.465070595 8.86660675,0.63323518 L8.86660675,5.69965549 C8.86660675,5.86782863 8.80006847,6.02897495 8.68104592,6.14766073 C8.56235717,6.2663508 8.40119827,6.33321693 8.23336329,6.33321693 L5.06650404,6.33321693 L5.06650404,7.59967223 L6.33333333,7.59967223 L6.33333333,8.86646988 L2.53327342,8.86646988 L2.53327342,7.59967223 L3.80010271,7.60000654 L3.80010271,6.33320889 L0.633243463,6.33320889 C0.465399923,6.33320889 0.304249583,6.26633847 0.18522703,6.14765269 C0.066533145,6.0289669 0,5.86781203 0,5.69964744 L0,0.63321909 C0,0.283512413 0.283519493,0 0.633234904,0 Z M7.60020542,1.26646334 L1.26648693,1.26646334 L1.26648693,5.06642835 L7.60020542,5.06676266 L7.60020542,1.26646334 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23336329,0 C8.40120683,0 8.56235717,0.0665366188 8.68104592,0.185222404 C8.79973895,0.304241984 8.86660675,0.465396859 8.86660675,0.633227648 L8.86660675,5.69999031 C8.86660675,5.86782966 8.79973467,6.02897598 8.68104592,6.14766176 C8.56235717,6.26635182 8.40119827,6.33321796 8.23336329,6.33321796 L5.06650404,6.33321796 L5.06650404,7.60001561 L6.33333333,7.60001561 L6.33333333,8.86681326 L2.53327342,8.86681326 L2.53327342,7.60001561 L3.80010271,7.60001561 L3.80010271,6.33321796 L0.633243463,6.33321796 C0.465066119,6.33321796 0.304249583,6.26634755 0.18522703,6.14766176 C0.066533145,6.02897598 0,5.8678211 0,5.69999031 L0,0.633227648 C0,0.283520972 0.283519493,0 0.633234904,0 Z M7.59986305,1.26647182 L1.26648693,1.26647182 L1.26648693,5.06643683 L7.60020542,5.06677122 L7.59986305,1.26647182 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58342962,0 L4.47879488,0.895342898 L3.1347627,2.23865681 L4.47879488,3.58197071 L3.58342962,4.47765597 L2.23939744,3.13434206 L0.895365259,4.47765597 L0,3.58197071 L1.34368982,2.23865681 L0,0.895342898 L0.895365259,0 L2.23939744,1.34331391 L3.58342962,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.97731416,0.18555192 C2.22474002,-0.06185064 2.62561304,-0.06185064 2.87302178,0.18555192 L6.45576668,3.76820734 L6.90344931,3.32053589 C7.0756323,3.14835634 7.33106946,3.08984794 7.5607609,3.17042195 C7.79074327,3.25135518 7.95389729,3.45730716 7.97997595,3.70002802 L8.42799298,7.73108239 C8.44805546,7.92131173 8.38118338,8.11054825 8.24577875,8.2456157 C8.11070792,8.38101866 7.92147524,8.44788479 7.73123259,8.42782538 L3.70042795,7.97981954 C3.45836864,7.95374068 3.25308084,7.79059159 3.17183635,7.56123967 C3.09092738,7.33155396 3.14876963,7.07578939 3.32061882,6.9032769 L3.76830145,6.45560545 L0.185556554,2.87295003 C-0.0618521847,2.62553035 -0.0618521847,2.22466734 0.185556554,1.97726478 Z M2.42501904,1.52891718 L1.52896906,2.42494479 L5.11171396,6.00760021 C5.34541447,6.24128291 5.36012753,6.61506567 5.14581675,6.86648234 L7.08197971,7.08117634 L6.86666752,5.14507542 C6.61526169,5.35937743 6.24146959,5.3446733 6.00776394,5.11097348 L2.42501904,1.52891718 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-180.0 -783.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.0 798.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 8.86660675,0 8.86660675,8.86681326 0,8.86681326 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.799837377498176 10.133705061970609)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.26682929,0 1.26682929,17.099757 0,17.099757 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.766071810673171 33.56702233887266)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12.6665811,0 12.6665811,1.26679765 0,1.26679765 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.93323062438481 10.766205206885711)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 1.26682929,0 1.26682929,12.6662647 0,12.6662647 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.76607181067317 3.166788716085706)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 16.4668122,0 16.4668122,1.26679765 0,1.26679765 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.33290537938118 25.33339341656766)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12.6666667,0 12.6666667,12.6661706 0,12.6661706 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.440892098500626e-15 29.133530118764057)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 8.86660675,0 8.86660675,8.86646988 0,8.86646988 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.13339324688662 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 8.86660675,0 8.86660675,8.86681326 0,8.86681326 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.42734625754268 28.16158537645609)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 4.47879488,0 4.47879488,4.47765597 0,4.47765597 0,0",
    stroke: "none",
    fill: "#2795E3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.63480549492874 15.634269532650467)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i11)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1.77635684e-15,0 8.43149425,0 8.43149425,8.43132592 -1.77635684e-15,8.43132592 -1.77635684e-15,0",
    stroke: "none",
    fill: "#2795E3"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkType);
export default __webpack_public_path__ + "static/media/network-type.e6b21ea438915ab1054d9c15e79cfc3f.svg";
export { ForwardRef as ReactComponent };